module.exports = __webpack_public_path__ + "img/shouye_c.834c4fa5.png";